var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBalloon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256 40.96c-50.811 0-92.16 41.349-92.16 92.16 0 5.652 4.587 10.24 10.24 10.24 5.652 0 10.24-4.588 10.24-10.24 0-39.526 32.154-71.68 71.68-71.68 5.652 0 10.24-4.588 10.24-10.24S261.652 40.96 256 40.96z",
    fill: "#f5f5f5",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.12 133.12C389.12 59.72 329.4 0 256 0S122.88 59.72 122.88 133.12c0 75.08 64.532 151.122 112.763 169.718l-7.373 7.352c-2.929 2.949-3.809 7.332-2.212 11.162a10.24 10.24 0 0 0 9.462 6.328h13.66c30.597 72.929 14.438 89.743-7.885 112.558-13.681 13.988-29.204 29.839-36.209 59.146-1.311 5.489 2.068 11.018 7.578 12.329a9.529 9.529 0 0 0 2.376.287c4.649 0 8.847-3.154 9.953-7.864 5.693-23.777 18.534-36.905 30.945-49.582 27.955-28.57 44.38-53.514 15.401-126.874h5.141a10.24 10.24 0 0 0 9.462-6.328c1.597-3.83.717-8.212-2.212-11.162l-7.373-7.352C324.588 284.242 389.12 208.2 389.12 133.12zM256 286.72c-35.41 0-112.64-77.107-112.64-153.6 0-62.116 50.524-112.64 112.64-112.64s112.64 50.524 112.64 112.64c0 76.493-77.23 153.6-112.64 153.6z",
    fill: "#f5f5f5",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalloon);
export default __webpack_public_path__ + "static/media/balloon.92f3dfa1ea28749d32f0fe544e0c77ec.svg";
export { ForwardRef as ReactComponent };